import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function PrePedidosExportToolbar({
  totalRegistros,
  exporting = false,
  exportProgress = null,
  onExport,
  disabled = false,
}) {
  const progressLabel =
    exportProgress?.phase === "details"
      ? `Carregando itens (${exportProgress.loaded}/${exportProgress.total})…`
      : exportProgress?.phase === "list"
        ? "Listando pré-pedidos…"
        : null;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      style={{
        gap: 12,
        marginBottom: 16,
        padding: "12px 16px",
        backgroundColor: themeColorsDesingSystem.background.main,
        border: `1px solid ${themeColorsDesingSystem.stone.main}`,
        borderRadius: 4,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        style={{ gap: 8 }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 600, margin: 0 }}>
          Pré-pedidos
        </Typography>
        {totalRegistros != null && (
          <Typography variant="body2" color="textSecondary">
            ({totalRegistros} {totalRegistros === 1 ? "registro" : "registros"})
          </Typography>
        )}
        {progressLabel && (
          <Typography variant="caption" color="textSecondary">
            {progressLabel}
          </Typography>
        )}
      </Box>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={onExport}
        disabled={disabled || exporting}
        startIcon={
          exporting ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <FileDownloadIcon fontSize="small" />
          )
        }
        style={{
          minWidth: 200,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {exporting ? "Gerando relatório…" : "Exportar XLSX"}
      </Button>
    </Box>
  );
}
